import { Component } from '@angular/core';
import { RouterLink } from "@angular/router";
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../../models/GenericCRUD/GenericTable';
import { GenericForm, GenericFormField } from '../../../../models/GenericCRUD/GenericForm';
import { Paginator } from '../../../../models/Paginator';
import { GenericCRUD } from '../../../../models/GenericCRUD/GenericCRUD';
import { Rate } from '../../../../models/Rate';
import { GenericCrudComponent } from "../../../../shared/components/generic-crud/generic-crud.component";
import { Filter } from '../../../../models/GenericCRUD/Filter';
import { BreadcrumbService } from '../../../../core/services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-rates-configuration',
  standalone: true,
  imports: [
    RouterLink,
    GenericCrudComponent
  ],
  templateUrl: './rates-configuration.component.html',
  styleUrl: './rates-configuration.component.css'
})
export class RatesConfigurationComponent {
  tableColums: GenericTableColumn[] = [
    { name: 'ID', active: false, type: 'text', key: 'id', sort: true },
    { name: 'Nombre', active: true, type: 'text', key: 'name', sort: true },
    { name: 'Código', active: true, type: 'text', key: 'code', sort: true },
    { name: 'Precio', active: true, type: 'currency', key: 'price', sort: true },
    { name: 'Descripción', active: true, type: 'text', key: 'description', sort: false },
    { name: 'Activa', active: true, type: 'boolean', key: 'active', sort: false },
    { name: 'Convocatorias por tasa', active: true, type: 'text', key: 'n_calls', sort: true },
    { name: 'Caducidad entre convocatorias (días)', active: true, type: 'text', key: 'expiry_between_calls', sort: true },
    { name: 'Fecha Creación', active: false, type: 'date', key: 'created_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
    { name: 'Fecha Modificación', active: false, type: 'date', key: 'updated_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
  ];


  formFields: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required' },
    { name: 'code', type: 'text', label: 'Código' },
    { name: 'price', type: 'text', label: 'Precio', validations: 'required' },
    { name: 'n_calls', type: 'number', label: 'Convocatorias por tasa (cobra cada N)' },
    { name: 'description', type: 'textarea', label: 'Descripción', colspan: 2 },
    { name: 'expiry_between_calls', type: 'number', label: 'Caducidad entre convocatorias (días)' },
    { name: 'active', type: 'boolean-switch', label: 'Activa' },
  ];

  formFieldsEdit: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required' },
    { name: 'code', type: 'text', label: 'Código' },
    { name: 'price', type: 'text', label: 'Precio', validations: 'required' },
    { name: 'n_calls', type: 'number', label: 'Convocatorias por tasa (cobra cada N)' },
    { name: 'description', type: 'textarea', label: 'Descripción', colspan: 2 },
    { name: 'expiry_between_calls', type: 'number', label: 'Caducidad entre convocatorias (días)' },
    { name: 'active', type: 'boolean-switch', label: 'Activa' },
  ];


  form: GenericForm = {
    successTitle: 'Creación correcta',
    errorTitle: 'Error en la creación',
    method: 'POST',
    fields: this.formFields,
    name: 'tasa',
    createButtonTitle: 'Nueva Tasa',
    cols: 2,
    createApiSlug: '/config/rate/store',
    formTitle: 'Crear Tasa',
    formButtonTitle: 'Crear Tasa',
    width: '4xl'
  }

  tableActions: GenericTableAction[] = [
    {
      name: 'Editar',
      key: 'edit',
      // actionSlug: '/config/office/update/{{id}}',
      form: {
        method: 'PUT',
        successTitle: 'Edición correcta',
        errorTitle: 'Error en la edición',
        fields: this.formFieldsEdit,
        name: 'rate',
        createButtonTitle: '',
        cols: 2,
        originalUpdateApiSlug: '/config/rate/update/{{id}}',
        createApiSlug: '',
        updateApiSlug: '',
        originalFormTitle: 'Editar {{name}}',
        formTitle: '',
        formButtonTitle: 'Editar',
        width: '4xl'
      },
      completeForm: true,
      replaceAllRowOnResponse: true,
      icon: '<svg  xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1.8"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" /><path d="M13.5 6.5l4 4" /><path d="M16 19h6" /></svg>',
      confirmation: false,

    },
    {
      name: 'Eliminar',
      key: 'delete',
      method: 'DELETE',
      icon: '<svg  xmlns="http://www.w3.org/2000/svg"  class="w-4 text-primary"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1.8"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>',
      confirmation: true,
      questionText: '¿ Desea eliminar la tasa ?',
      deleteRowOnResponse: true,
      actionSlug: '/config/rate/delete/{{id}}',
    }
  ]

  table: GenericTable<Paginator<Rate>> = {
    columns: this.tableColums,
    items: [],
    type: 'generic',
    loadItemsSlug: '/config/rate/index',
    paginate: true,
    name: 'tasas',
    actions: this.tableActions
  };

  filters: Filter[] = [
    { type: 'search', key: 'name|description', operator: 'like', placeholder: 'Nombre o descripción' },
    //{type: 'date-between', key: 'created_at', operator: 'between', parsed: "date-arr", placeholder: 'Fecha de creación'},
  ];

  genericCRUD: GenericCRUD<Paginator<Rate>> = {
    genericForm: this.form,
    genericTable: this.table,
    genericFilters: this.filters,
    useModalForm: false
  }
}
